import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionSignalsStateService } from './application/session/session-store.service';
import { IStorageRepository } from './domain/storage';
import { ToastHostComponent } from './presentation/_common/toast/toast-host.component';
import { rightValue } from './util/either';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastHostComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private sessionStore = inject(SessionSignalsStateService);
  private storage = inject(IStorageRepository);

  constructor() {
    const tokenResult = this.storage.getStorage('token');
    const token = tokenResult.isRight() ? rightValue(tokenResult) : '';

    this.sessionStore.set('token', token);
    this.sessionStore.set('isLogged', !!token);
  }
}
